import axios from 'axios';
import localforage from 'localforage';
import memoryDriver from 'localforage-memoryStorageDriver';
import { setupCache } from 'axios-cache-adapter';

/**
 Axios Cache
 */
const store = localforage.createInstance({
	// List of drivers used
	driver: [
		localforage.INDEXEDDB,
		localforage.LOCALSTORAGE,
		memoryDriver
	],
	// Prefix all storage keys to prevent conflicts
	// name: 'kapp'
});

const cache = setupCache({
	maxAge: 15 * 60 * 1000,
	store
});

const api = axios.create({
	adapter: cache.adapter,
});

let dev = process.env.NODE_ENV == 'development';

 export const ApiDefaults = {
	url: dev ? '//kassecker.c3-coding.de/backend/' : window.location.origin + '/backend/',
	timeout: 20000,
	method: 'GET',
	withCredentials: ! dev,
	responseType: 'application/json',
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
		// 'Origin' : 'https://app.kassecker.de'
	}
};



export default api;
//
// export const apiCall = ({url, settings, params}) => new Promise( (resolve, reject) => {
//
// 	if( typeof settings === 'undefined' ) settings = {};
//
// 	Object.assign( settings, ApiDefaults );
// 	console.log( 'apiCall', settings, url, params );
// 	let isLoading = true;
//
// 	api.get(url,settings)
// 		.then((response) => {
// 			resolve( response.data );
// 		})
// 		.catch((err)=>{
// 			reject( err );
// 		})
// 		.finally(()=>{
// 			isLoading = false;
// 		});
// });



// WEBPACK FOOTER //
// ./src/utils/api_call.js